import { render, staticRenderFns } from "./home-section.component.vue?vue&type=template&id=12f46f36&scoped=true"
import script from "./home-section.component.vue?vue&type=script&lang=ts"
export * from "./home-section.component.vue?vue&type=script&lang=ts"
import style0 from "./home-section.style.scss?vue&type=style&index=0&id=12f46f36&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f46f36",
  null
  
)

export default component.exports